/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { GooglePayIntermediateSigningKeyViewModel } from "../types/GooglePayIntermediateSigningKeyViewModel.ts";

export const googlePayIntermediateSigningKeyViewModelSchema = z.object({
  signedKey: z.string().nullish(),
  signatures: z.array(z.string()).nullish(),
}) as unknown as ToZod<GooglePayIntermediateSigningKeyViewModel>;
